// extracted by mini-css-extract-plugin
module.exports = {"shadow":"tag_shadow__qs9gP","textShadow":"tag_textShadow__2uRuq","tag":"tag_tag__RudyJ","name":"tag_name__1nGIa","icon":"tag_icon__2yAyT","removable":"tag_removable__mzmsm"};